<script>
	import { onMount } from 'svelte'
	import { fade, fly, slide as slideAnim } from 'svelte/transition'
	import { quadInOut } from 'svelte/easing'
	import { throttle, debounce } from 'throttle-debounce'
	import dlv from 'dlv'
	import Lethargy from 'lethargy'
	import { activeSlideIndex, tooTallSlides } from './stores'
	import HomeIntro from './home-slides/home-intro.svelte'

	export let hideIntro

	let breakWidth = 800

	// export let data = {}
	// console.log('data', data)

	let slidesEl = document.getElementById('slides')
	let slides = Array.from(slidesEl.children)
	slidesEl.parentElement.removeChild(slidesEl)

	let touchStartY

	let direction = 'down'

	let slideOneContentWrap
	let slideTwoContentWrap
	let lineHeight
	let screenHeight = window.innerHeight
	let screenWidth
	let footerSlide
	let showFooter

	// fix scroll momentum issues w/ magic mouse, etc
	let lethargy = new Lethargy.Lethargy()
	// window.testy = Lethargy

	function mouseWheelNext(e) {
		if ($tooTallSlides) {
			return
		}
		const userScroll = lethargy.check(e)
		if (userScroll !== false) {
			direction = userScroll < 0 ? 'down' : 'up'
			changeSlide()
		}
	}

	function touchmoveNext({ changedTouches }) {
		if ($tooTallSlides) {
			return
		}
		const distY = changedTouches[0].pageY - touchStartY
		if (distY < -30) {
			direction = 'down'
			changeSlide()
		}
		if (distY > 30) {
			direction = 'up'
			changeSlide()
		}
	}

	function arrowKeysChangeSlide(e) {
		if ($tooTallSlides) {
			return
		}
		let { keyCode } = e
		// down arrow
		keyCode === 40 && nextSlide(e)
		keyCode === 38 && previousSlide(e)
	}

	const changeSlide = throttle(600, true, () => {
		if (direction === 'down') {
			// change down
			let nextIndex = $activeSlideIndex + 1
			let downSlide = slides[nextIndex]
			if (downSlide) {
				$activeSlideIndex = nextIndex
				// $pathTwoPoints = $activeSlideIndex.points
			} else {
				// show footer
				showFooter = true
			}
		} else {
			// change up
			if (showFooter) {
				showFooter = false
				return
			}
			let nextIndex = $activeSlideIndex - 1
			let upSlide = slides[nextIndex]
			if (upSlide) {
				$activeSlideIndex = nextIndex
				// $pathTwoPoints = $activeSlideIndex.points
			}
		}
	})

	function nextSlide(e) {
		e.preventDefault()
		direction = 'down'
		changeSlide()
	}

	function previousSlide(e) {
		e.preventDefault()
		direction = 'up'
		changeSlide()
	}

	function checkIfAnySlideIsTooTallForScreen(node) {
		// check if height of any slide is greater than window height
		setTimeout(() => {
			if (screenWidth <= breakWidth || node.clientHeight > screenHeight) {
				$tooTallSlides = true
			}
		}, 0)
		return {
			update: debounce(150, ([height, width]) => {
				if (screenWidth <= breakWidth || node.clientHeight > height) {
					$tooTallSlides = true
				}
			}),
		}
	}

	let navbarHtml = ''

	onMount(() => {
		// let { fonts } = document
		// put navbar in slide one
		let navbarWrap = document.getElementById('navbar_wrap')
		let footer = document.getElementById('footer')
		navbarWrap.parentElement.removeChild(navbarWrap)
		footer.parentElement.removeChild(footer)
		// homeNavbarWrap.appendChild(navbarWrap)
		navbarHtml = navbarWrap.outerHTML
		footerSlide.appendChild(footer)
		// adjust line height on font load (or timeout)
		// if (fonts) {
		// 	fonts.ready.then(adjustLineHeight)
		// } else {
		// 	setTimeout(adjustLineHeight, 20)
		// }
	})
</script>

<svelte:window
	bind:innerHeight={screenHeight}
	bind:innerWidth={screenWidth}
	on:keyup={arrowKeysChangeSlide} />

{#if !hideIntro}
	<HomeIntro />
{/if}

<div
	class="fp-slides direction-{direction} viewing-{$activeSlideIndex + 1}"
	class:showFooter
	class:tooTallSlides={$tooTallSlides}
	on:touchstart={({ changedTouches }) => (touchStartY = changedTouches[0].pageY)}
	on:touchmove={e => !tooTallSlides && e.preventDefault()}
	on:touchend={touchmoveNext}
	on:wheel|stopPropagation={mouseWheelNext}>
	<!-- {@debug slides} -->
	{#if screenHeight >= 1100 && !$tooTallSlides}
		<div
			class="home-navbar-wrap"
			class:light={$activeSlideIndex === 0 || $activeSlideIndex === 2}>
			{@html navbarHtml}
			{@html navbarHtml.replace('light', 'dark')}
		</div>
	{/if}
	<div
		class="fp-slides-inner"
		style="transform: translateY({$activeSlideIndex * screenHeight * -1 + (showFooter ? footerSlide.offsetHeight * -1 : 0)}px)">
		{#if screenHeight < 1100 || $tooTallSlides}
			{@html navbarHtml}
		{/if}
		{#each slides as slide, i}
			<div
				class="fp-slide fp-slide-{i + 1}"
				class:active-slide={i === $activeSlideIndex}
				use:checkIfAnySlideIsTooTallForScreen={[screenHeight, screenWidth]}
				style="min-height: {screenWidth > breakWidth ? screenHeight : 0}px">
				{@html slide.outerHTML}
			</div>
		{/each}

		<div class="footer-slide" bind:this={footerSlide} />

	</div>

</div>
